<!-- <div class="base" *ngIf="vinInfo.vin_number || itemCode">
  <div class="base__info ml-auto">
    <span class="base__infoItem mb-2"><span class="font-weight-medium">VIN No.:</span> {{ vinInfo.vin_number }}</span>
    <span class="base__infoItem"><span class="font-weight-medium">Item Code:</span> {{ itemCode }}</span>
  </div>
</div> -->

<section class="vam_information_section information py-5">
  <div class="container">
    <form
      class="vam_information_form credential2 credential3"
      [formGroup]="informationForm"
      (submit)="saveData()"
    >
      <div class="row">
        <div class="col-sm-6 col-md-4 mb-3">
          <div class="form-group">
            <label class="credential2__label">
              {{ 'information.vin_number' | translate }}
              <button
                type="button"
                class="btn btn__action ml-3"
                [id]="'information.vin_number' | translate"
                (click)="openUpload($event, 'vin')"
              >
                <ion-icon name="image-outline" class="ion-lg"></ion-icon>
              </button>
            </label>
            <input
              type="text"
              name="vin_number"
              formControlName="vin_number"
              [placeholder]="'information.enter_vin_number' | translate"
              class="credential3__input form-control"
              [readonly]="role === 'estimator' || role === 'qc' || role === 'purchasemanager'"
              [class.is-invalid]="formData.vin_number.invalid && submitted"
            />
            <div class="form-errors" *ngIf="formData.vin_number.invalid && submitted">
              <p class="form-errors__error" *ngIf="formData.vin_number.errors.required">
                <!-- VIN no. is required. -->
                {{ 'errors.info.vin_number.required' | translate }}
              </p>

              <p class="form-errors__error" *ngIf="formData.vin_number.errors.pattern">
                <!-- VIN no. should be alphanumerical only. -->
                {{ 'errors.info.vin_number.pattern_1' | translate }}
              </p>

              <p class="form-errors__error" *ngIf="formData.vin_number.errors.maxlength">
                <!-- VIN no. should not be more than 21 characters. -->
                {{ 'errors.info.vin_number.pattern_2' | translate }}
              </p>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-md-4 mb-3">
          <div class="form-group">
            <label class="credential2__label">
              {{ 'information.plate_number' | translate }}

              <button
                type="button"
                class="btn btn__action ml-3"
                [id]="'information.plate_number' | translate"
                (click)="openUpload($event, 'plate')"
              >
                <ion-icon name="image-outline" class="ion-lg"></ion-icon>
              </button>
            </label>
            <input
              type="text"
              name="plate_number"
              formControlName="plate_number"
              [placeholder]="'information.enter_plate_number' | translate"
              class="credential3__input form-control"
              [class.is-invalid]="formData.plate_number.invalid && submitted"
              [readonly]="role === 'estimator' || role === 'qc' || role === 'purchasemanager'"
            />

            <div class="form-errors" *ngIf="formData.plate_number.invalid && this.submitted">
              <p class="form-errors__error" *ngIf="formData.plate_number.errors.required">
                <!-- Plate no. is required. -->
                {{ 'errors.info.plate_number.required' | translate }}
              </p>

              <p class="form-errors__error" *ngIf="formData.plate_number.errors.pattern">
                <!-- Plate no. should be alphanumerical only. -->
                {{ 'errors.info.plate_number.pattern_1' | translate }}
              </p>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-md-4 mb-3">
          <div class="form-group">
            <label class="credential2__label">{{
              'information.assessment_type' | translate
            }}</label>
            <select
              name="assessment_type_id"
              formControlName="assessment_type_id"
              class="credential3__select form-control"
              [class.is-invalid]="formData.assessment_type_id.invalid && submitted"
              [attr.disabled]="
                role === 'estimator' || role === 'qc' || role === 'purchasemanager' ? '' : null
              "
            >
              <option value="">{{ 'information.select_assessment_type' | translate }}</option>
              <option [value]="item.assessment_type_id" *ngFor="let item of assessment_type">
                <ng-container *ngIf="lang === 'en'">{{ item.assessment_type_name }}</ng-container>
                <ng-container *ngIf="lang === 'ar'">{{
                  item.assessment_type_name_arabic
                }}</ng-container>
              </option>
            </select>

            <div class="form-errors" *ngIf="formData.assessment_type_id.invalid && this.submitted">
              <p class="form-errors__error" *ngIf="formData.assessment_type_id.errors.required">
                <!-- Assessment type is required. -->
                {{ 'errors.info.assessment_type.required' | translate }}
              </p>
            </div>
          </div>
        </div>

        <div class="col-sm-6 col-md-4 mb-3">
          <div class="form-group">
            <label class="credential2__label">{{ 'information.condition' | translate }}</label>
            <select
              name="vehicle_condition_id"
              formControlName="vehicle_condition_id"
              class="credential3__select form-control"
              [class.is-invalid]="formData.vehicle_condition_id.invalid && submitted"
              [attr.disabled]="
                role === 'estimator' || role === 'qc' || role === 'purchasemanager' ? '' : null
              "
            >
              <option value="" [disabled]="true">
                {{ 'information.select_condition' | translate }}
              </option>
              <option [value]="condition.condition_id" *ngFor="let condition of conditions">
                <ng-container *ngIf="lang == 'en'">{{ condition.condition_name }}</ng-container>
                <ng-container *ngIf="lang == 'ar'">{{
                  condition.condition_name_arabic
                }}</ng-container>
              </option>
            </select>

            <div
              class="form-errors"
              *ngIf="formData.vehicle_condition_id.invalid && this.submitted"
            >
              <p class="form-errors__error" *ngIf="formData.vehicle_condition_id.errors.required">
                <!-- Condition is required. -->
                {{ 'errors.info.condition.required' | translate }}
              </p>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-md-4 mb-3">
          <div class="form-group">
            <label class="credential2__label">{{ 'information.engine_type' | translate }}</label>
            <select
              name="engine_type_id"
              formControlName="engine_type_id"
              class="credential3__select form-control"
              [class.is-invalid]="formData.engine_type_id.invalid && submitted"
              [attr.disabled]="
                role === 'estimator' || role === 'qc' || role === 'purchasemanager' ? '' : null
              "
            >
              <option value="">{{ 'information.select_engine_type' | translate }}</option>
              <option [value]="item.engine_type_id" *ngFor="let item of engine">
                <ng-container *ngIf="lang == 'en'">{{ item.engine_type_name }}</ng-container>
                <ng-container *ngIf="lang == 'ar'">{{ item.engine_type_name_arabic }}</ng-container>
              </option>
            </select>

            <div class="form-errors" *ngIf="formData.engine_type_id.invalid && this.submitted">
              <p class="form-errors__error" *ngIf="formData.engine_type_id.errors.required">
                <!-- Engine type is required. -->
                {{ 'errors.info.engine_type.required' | translate }}
              </p>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-md-4 mb-3">
          <div class="form-group">
            <label class="credential2__label">{{ 'information.vendor' | translate }}</label>
            <input
              type="text"
              name="vendor_id"
              formControlName="vendor_id"
              [placeholder]="'information.select_vendor' | translate"
              class="credential3__input form-control"
              [class.is-invalid]="formData.vendor_id.invalid && submitted"
              [readonly]="role === 'estimator' || role === 'qc' || role === 'purchasemanager'"
            />

            <div class="form-errors" *ngIf="formData.vendor_id.invalid && this.submitted">
              <p class="form-errors__error" *ngIf="formData.vendor_id.errors.required">
                <!-- Vendor is required. -->
                {{ 'errors.info.vendor.required' | translate }}
              </p>

              <p class="form-errors__error" *ngIf="formData.vendor_id.errors.pattern">
                Vendor should be alphabetical only.
              </p>
            </div>
          </div>
        </div>

        <div class="col-sm-6 col-md-4 mb-3">
          <div class="form-group">
            <label class="credential2__label">
              {{ 'information.origin' | translate }}
            </label>
            <select
              name="vehicle_origin_id"
              formControlName="vehicle_origin_id"
              class="credential3__select form-control"
              [class.is-invalid]="formData.vehicle_origin_id.invalid && submitted"
              [attr.disabled]="
                role === 'estimator' || role === 'qc' || role === 'purchasemanager' ? '' : null
              "
            >
              <option value="" [disabled]="true">Select Origin</option>
              <option [value]="origin.vehicle_origin_id" *ngFor="let origin of origins">
                <ng-container *ngIf="lang == 'en'">{{ origin.vehicle_origin_name }}</ng-container>
                <ng-container *ngIf="lang == 'ar'">{{
                  origin.vehicle_origin_name_arabic
                }}</ng-container>
              </option>
            </select>

            <div class="form-errors" *ngIf="formData.vehicle_origin_id.invalid && this.submitted">
              <p class="form-errors__error" *ngIf="formData.vehicle_origin_id.errors.required">
                Origin is required.
                <!-- {{ 'errors.info.origin.required' | translate }} -->
              </p>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-md-4 mb-3">
          <div class="form-group">
            <label class="credential2__label">{{ 'information.fuel_type' | translate }}</label>
            <select
              name="fuel_type_id"
              formControlName="fuel_type_id"
              class="credential3__select form-control"
              [class.is-invalid]="formData.fuel_type_id.invalid && submitted"
              [attr.disabled]="
                role === 'estimator' || role === 'qc' || role === 'purchasemanager' ? '' : null
              "
            >
              <option value="" [disabled]="true">
                {{ 'information.select_fuel_type' | translate }}
              </option>
              <option [value]="item.fuel_type_id" *ngFor="let item of fuel">
                <ng-container *ngIf="lang == 'en'">{{ item.type_name }}</ng-container>
                <ng-container *ngIf="lang == 'ar'">{{ item.type_name_arabic }}</ng-container>
              </option>
            </select>

            <div class="form-errors" *ngIf="formData.fuel_type_id.invalid && this.submitted">
              <p class="form-errors__error" *ngIf="formData.fuel_type_id.errors.required">
                <!-- Fuel type is required. -->
                {{ 'errors.info.fuel_type.required' | translate }}
              </p>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-md-4 mb-3">
          <div class="form-group">
            <label class="credential2__label">{{ 'information.estimara' | translate }}</label>
            <select
              name="estimara_id"
              formControlName="estimara_id"
              class="credential3__select form-control"
              [class.is-invalid]="formData.estimara_id.invalid && submitted"
              [attr.disabled]="
                role === 'estimator' || role === 'qc' || role === 'purchasemanager' ? '' : null
              "
            >
              <option value="">{{ 'information.select_estimara' | translate }}</option>
              <option [value]="item.estimara_id" *ngFor="let item of estimara_type">
                <ng-container *ngIf="lang === 'en'">{{ item.estimara_name }}</ng-container>
                <ng-container *ngIf="lang === 'ar'">{{ item.estimara_name_arabic }}</ng-container>
              </option>
            </select>

            <div class="form-errors" *ngIf="formData.estimara_id.invalid && this.submitted">
              <p class="form-errors__error" *ngIf="formData.estimara_id.errors.required">
                <!-- Estimara is required. -->
                {{ 'errors.info.estimara.required' | translate }}
              </p>
            </div>
          </div>
        </div>

        <div class="col-sm-6 col-md-4 mb-3">
          <div class="form-group">
            <label class="credential2__label">{{ 'information.make' | translate }}</label>
            <select
              #makeId
              name="make_id"
              formControlName="make_id"
              class="credential3__select form-control"
              [class.is-invalid]="formData.make_id.invalid && submitted"
              [attr.disabled]="
                role === 'estimator' || role === 'qc' || role === 'purchasemanager' ? '' : null
              "
              (change)="getModelYearType($event)"
            >
              <option value="">{{ 'information.select_make' | translate }}</option>
              <option *ngFor="let item of make" [value]="item.make_id">
                <ng-container *ngIf="lang === 'en'">{{ item.maker_name }}</ng-container>
                <ng-container *ngIf="lang === 'ar'">{{ item.maker_name_arabic }}</ng-container>
              </option>
            </select>

            <div class="form-errors" *ngIf="formData.make_id.invalid && this.submitted">
              <p class="form-errors__error" *ngIf="formData.make_id.errors.required">
                <!-- Make is required. -->
                {{ 'errors.info.make.required' | translate }}
              </p>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-md-4 mb-3">
          <div class="form-group">
            <label class="credential2__label">{{ 'information.cc' | translate }}</label>
            <select
              name="engine_cc_id"
              formControlName="engine_cc_id"
              class="credential3__select form-control"
              [class.is-invalid]="formData.engine_cc_id.invalid && submitted"
              [attr.disabled]="
                role === 'estimator' || role === 'qc' || role === 'purchasemanager' ? '' : null
              "
            >
              <option value="">{{ 'information.enter_cc' | translate }}</option>
              <option [value]="item.engine_cc_id" *ngFor="let item of engine_cc">
                <ng-container *ngIf="lang === 'en'">
                  {{ item.engine_cc_name }}
                </ng-container>
                <ng-container *ngIf="lang === 'ar'">
                  {{ item.engine_cc_name_arabic }}
                </ng-container>
              </option>
            </select>

            <div class="form-errors" *ngIf="formData.engine_cc_id.invalid && this.submitted">
              <p class="form-errors__error" *ngIf="formData.engine_cc_id.errors.required">
                <!-- CC is required. -->
                {{ 'errors.info.cc.required' | translate }}
              </p>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-md-4 mb-3">
          <div class="form-group">
            <label class="credential2__label">{{ 'information.service_and_maintenance_status' | translate }}</label>
            <select
              name="service_maintainance"
              formControlName="service_maintainance"
              class="credential3__select form-control"
              [class.is-invalid]="formData.service_maintainance.invalid && submitted"
              [attr.disabled]="
                role === 'estimator' || role === 'qc' || role === 'purchasemanager' ? '' : null
              "
            >
              <option value="" [disabled]="true">Select status</option>
              <option [value]="service.service_id" *ngFor="let service of services">
                <ng-container *ngIf="lang == 'en'">{{ service.service_name }}</ng-container>
                <ng-container *ngIf="lang == 'ar'">{{ service.service_name_arabic }}</ng-container>
              </option>
            </select>

            <div
              class="form-errors"
              *ngIf="formData.service_maintainance.invalid && this.submitted"
            >
              <p class="form-errors__error" *ngIf="formData.service_maintainance.errors.required">
                Service and maintenance status is required.
                <!-- {{ 'errors.info.service_maintainance.required' | translate }} -->
              </p>
            </div>
          </div>
        </div>

        <div class="col-sm-6 col-md-4 mb-3">
          <div class="form-group">
            <label class="credential2__label">{{ 'information.model_yr' | translate }}</label>
            <select
              name="model_year_id"
              formControlName="model_year_id"
              class="credential3__select form-control"
              [attr.disabled]="
                role === 'estimator' || role === 'qc' || role === 'purchasemanager' ? '' : null
              "
              [class.is-invalid]="formData.model_year_id.invalid && submitted"
              (change)="getModelType($event, makeId.value)"
            >
              <option value="">{{ 'information.select_model_yr' | translate }}</option>
              <option [value]="item.year_id" *ngFor="let item of model_year">
                <ng-container *ngIf="lang === 'en'">{{ item.year_value }}</ng-container>
                <ng-container *ngIf="lang === 'ar'">{{ item.year_value }}</ng-container>
              </option>
            </select>

            <div class="form-errors" *ngIf="formData.model_year_id.invalid && this.submitted">
              <p class="form-errors__error" *ngIf="formData.model_year_id.errors.required">
                <!-- Model year is required. -->
                {{ 'errors.info.model_year.required' | translate }}
              </p>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-md-4 mb-3">
          <div class="form-group">
            <label class="credential2__label">{{ 'information.cylinders' | translate }}</label>
            <select
              name="cyllinder_id"
              formControlName="cyllinder_id"
              class="credential3__select form-control"
              [class.is-invalid]="formData.cyllinder_id.invalid && submitted"
              [attr.disabled]="
                role === 'estimator' || role === 'qc' || role === 'purchasemanager' ? '' : null
              "
            >
              <option value="">{{ 'information.enter_cylinders' | translate }}</option>
              <option [value]="item.cyllinder_id" *ngFor="let item of cyllinders">
                <ng-container *ngIf="lang === 'en'">{{ item.cyllinder_name }}</ng-container>
                <ng-container *ngIf="lang === 'ar'">{{ item.cyllinder_name_arabic }}</ng-container>
              </option>
            </select>

            <div class="form-errors" *ngIf="formData.cyllinder_id.invalid && this.submitted">
              <p class="form-errors__error" *ngIf="formData.cyllinder_id.errors.required">
                <!-- Cylinders is required. -->
                {{ 'errors.info.cylinders.required' | translate }}
              </p>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-md-4 mb-3">
          <div class="form-group">
            <label class="credential2__label">
              {{ 'information.odo' | translate }}

              <button
                type="button"
                class="btn btn__action ml-3"
                [id]="'information.odo' | translate"
                (click)="openUpload($event, 'odo')"
              >
                <ion-icon name="image-outline" class="ion-lg"></ion-icon>
              </button>
            </label>
            <input
              type="text"
              name="odo"
              formControlName="odo"
              [placeholder]="'information.enter_odo_reading' | translate"
              class="credential3__input form-control"
              [class.is-invalid]="formData.odo.invalid && submitted"
              [readonly]="role === 'estimator' || role === 'qc' || role === 'purchasemanager'"
            />

            <div class="form-errors" *ngIf="formData.odo.invalid && this.submitted">
              <p class="form-errors__error" *ngIf="formData.odo.errors.required">
                <!-- ODO is required. -->
                {{ 'errors.info.odo.required' | translate }}
              </p>

              <p class="form-errors__error" *ngIf="formData.odo.errors.pattern">
                <!-- ODO should be numerical only. -->
                {{ 'errors.info.odo.pattern_1' | translate }}
              </p>
            </div>
          </div>
        </div>

        <div class="col-sm-6 col-md-4 mb-3">
          <div class="form-group">
            <label class="credential2__label">{{ 'information.model' | translate }}</label>
            <select
              name="model_id"
              formControlName="model_id"
              class="credential3__select form-control"
              [class.is-invalid]="formData.model_id.invalid && submitted"
              [attr.disabled]="
                role === 'estimator' || role === 'qc' || role === 'purchasemanager' ? '' : null
              "
              (change)="getTrimType($event)"
            >
              <option value="">{{ 'information.select_model' | translate }}</option>
              <option [value]="model.model_id" *ngFor="let model of models">
                <ng-container *ngIf="lang === 'en'">
                  {{ model.model_name }}
                </ng-container>
                <ng-container *ngIf="lang === 'ar'">
                  {{ model.model_name_arabic }}
                </ng-container>
              </option>
            </select>

            <div class="form-errors" *ngIf="formData.model_id.invalid && this.submitted">
              <p class="form-errors__error" *ngIf="formData.model_id.errors.required">
                <!-- Model is required. -->
                {{ 'errors.info.model.required' | translate }}
              </p>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-md-4 mb-3">
          <div class="form-group">
            <label class="credential2__label">{{
              'information.transmission_type' | translate
            }}</label>
            <select
              name="transmission_type_id"
              formControlName="transmission_type_id"
              class="credential3__select form-control"
              [class.is-invalid]="formData.transmission_type_id.invalid && submitted"
              [attr.disabled]="
                role === 'estimator' || role === 'qc' || role === 'purchasemanager' ? '' : null
              "
            >
              <option value="">{{ 'information.select_transmission_type' | translate }}</option>
              <option [value]="item.transmission_type_id" *ngFor="let item of transamission_type">
                <ng-container *ngIf="lang === 'en'">{{ item.transmission_type_name }}</ng-container>
                <ng-container *ngIf="lang === 'ar'">{{
                  item.transmission_type_name_arabic
                }}</ng-container>
              </option>
            </select>
            <div
              class="form-errors"
              *ngIf="formData.transmission_type_id.invalid && this.submitted"
            >
              <p class="form-errors__error" *ngIf="formData.transmission_type_id.errors.required">
                <!-- Transmission type is required. -->
                {{ 'errors.info.transmission_type.required' | translate }}
              </p>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-md-4 mb-3">
          <div class="form-group">
            <label class="credential2__label">{{ 'information.max_speed' | translate }}</label>
            <select
              name="max_speed"
              formControlName="max_speed"
              class="credential3__select form-control"
              [class.is-invalid]="formData.max_speed.invalid && submitted"
              [attr.disabled]="
                role === 'estimator' || role === 'qc' || role === 'purchasemanager' ? '' : null
              "
            >
              <option value="">Select Max Speed</option>
              <option [value]="speed.max_speed_id" *ngFor="let speed of maxSpeed">
                <ng-container *ngIf="lang == 'en'">{{ speed.max_speed_name }}</ng-container>
                <ng-container *ngIf="lang == 'ar'">{{ speed.max_speed_name_arabic }}</ng-container>
              </option>
            </select>

            <div class="form-errors" *ngIf="formData.max_speed.invalid && this.submitted">
              <p class="form-errors__error" *ngIf="formData.max_speed.errors.required">
                Max Speed is required.
                <!-- {{ 'errors.info.max_speed.required' | translate }} -->
              </p>
            </div>
          </div>
        </div>

        <div class="col-sm-6 col-md-4 mb-3">
          <div class="form-group">
            <label class="credential2__label">{{ 'information.trim_/_type' | translate }}</label>
            <select
              name="trim_id"
              formControlName="trim_id"
              class="credential3__select form-control"
              [class.is-invalid]="formData.trim_id.invalid && submitted"
              [attr.disabled]="
                role === 'estimator' || role === 'qc' || role === 'purchasemanager' ? '' : null
              "
            >
              <option value="">Select Trim/Type</option>
              <option [value]="item.trim_id" *ngFor="let item of trim_type">
                <ng-container *ngIf="lang == 'en'">{{ item.trim_name }}</ng-container>
                <ng-container *ngIf="lang == 'ar'">{{ item.trim_name_arabic }}</ng-container>
              </option>
            </select>

            <div class="form-errors" *ngIf="formData.trim_id.invalid && this.submitted">
              <p class="form-errors__error" *ngIf="formData.trim_id.errors.required">
                <!-- Trim/Type is required. -->
                {{ 'errors.info.trim_type.required' | translate }}
              </p>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-md-4 mb-3">
          <div class="form-group">
            <label class="credential2__label">{{ 'information.gear' | translate }}</label>
            <select
              name="gear_id"
              formControlName="gear_id"
              class="credential3__select form-control"
              [class.is-invalid]="formData.gear_id.invalid && submitted"
              [attr.disabled]="
                role === 'estimator' || role === 'qc' || role === 'purchasemanager' ? '' : null
              "
            >
              <option value="" [disabled]="true" [selected]="true">
                {{ 'information.select_gear' | translate }}
              </option>
              <option [value]="gear.gear_id" *ngFor="let gear of gears">
                <ng-container *ngIf="lang == 'en'">{{ gear.gear_name }}</ng-container>
                <ng-container *ngIf="lang == 'ar'">{{ gear.gear_name_arabic }}</ng-container>
              </option>
            </select>

            <div class="form-errors" *ngIf="formData.gear_id.invalid && this.submitted">
              <p class="form-errors__error" *ngIf="formData.gear_id.errors.required">
                Gear is required.
                <!-- {{ 'errors.info.gears.required' | translate }} -->
              </p>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-md-4 mb-3">
          <div class="form-group">
            <label class="credential2__label">{{ 'information.mileage' | translate }}</label>
            <select
              name="mileage_id"
              formControlName="mileage_id"
              class="credential3__select form-control"
              [class.is-invalid]="formData.mileage_id.invalid && submitted"
              [attr.disabled]="
                role === 'estimator' || role === 'qc' || role === 'purchasemanager' ? '' : null
              "
            >
              <option value="" [disabled]="true">Select Mileage</option>
              <option [value]="mileage.mileage_info_id" *ngFor="let mileage of mileages">
                <ng-container *ngIf="lang == 'en'">{{ mileage.mileage_info_name }}</ng-container>
                <ng-container *ngIf="lang == 'ar'">{{
                  mileage.mileage_info_name_arabic
                }}</ng-container>
              </option>
            </select>

            <div class="form-errors" *ngIf="formData.mileage_id.invalid && this.submitted">
              <p class="form-errors__error" *ngIf="formData.mileage_id.errors.required">
                Mileage is required.
                <!-- {{ 'errors.info.mileage.required' | translate }} -->
              </p>
            </div>
          </div>
        </div>

        <div class="col-sm-6 col-md-4 mb-3">
          <div class="form-group">
            <label class="credential2__label"> {{ 'information.vehicle_type' | translate }} </label>
            <select
              name="vehicle_type_id"
              formControlName="vehicle_type_id"
              class="credential3__select form-control"
              [class.is-invalid]="formData.vehicle_type_id.invalid && submitted"
              [attr.disabled]="
                role === 'estimator' || role === 'qc' || role === 'purchasemanager' ? '' : null
              "
            >
              <option value="">{{ 'information.select_vehicle_type' | translate }}</option>
              <option [value]="item.type_id" *ngFor="let item of vehicle_type">
                <ng-container *ngIf="lang === 'en'">{{ item.type_name }}</ng-container>
                <ng-container *ngIf="lang === 'ar'">{{ item.type_name_arabic }}</ng-container>
              </option>
            </select>

            <div class="form-errors" *ngIf="formData.vehicle_type_id.invalid && this.submitted">
              <p class="form-errors__error" *ngIf="formData.vehicle_type_id.errors.required">
                <!-- Vehicle type is required. -->
                {{ 'errors.info.vehicle_type.required' | translate }}
              </p>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-md-4 mb-3">
          <div class="form-group">
            <label class="credential2__label">{{ 'information.seats' | translate }}</label>
            <select
              name="seat_id"
              formControlName="seat_id"
              class="credential3__select form-control"
              [class.is-invalid]="formData.seat_id.invalid && submitted"
              [attr.disabled]="
                role === 'estimator' || role === 'qc' || role === 'purchasemanager' ? '' : null
              "
            >
              <option value="">{{ 'information.select_seats' | translate }}</option>
              <option [value]="seat.seat_id" *ngFor="let seat of seats">
                <ng-container *ngIf="lang == 'en'">{{ seat.seat_name }}</ng-container>
                <ng-container *ngIf="lang == 'ar'">{{ seat.seat_name_arabic }}</ng-container>
              </option>
            </select>

            <div class="form-errors" *ngIf="formData.seat_id.invalid && this.submitted">
              <p class="form-errors__error" *ngIf="formData.seat_id.errors.required">
                Seat is required.
                <!-- {{ 'errors.info.seat.required' | translate }} -->
              </p>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-md-4 mb-3">
          <div class="form-group">
            <label class="credential2__label">{{
              'information.exterior_colour' | translate
            }}</label>
            <select
              name="exterior_color_id"
              formControlName="exterior_color_id"
              class="credential3__select form-control"
              [class.is-invalid]="formData.exterior_color_id.invalid && submitted"
              [attr.disabled]="
                role === 'estimator' || role === 'qc' || role === 'purchasemanager' ? '' : null
              "
            >
              <option value="">{{ 'information.select_exterior_colour' | translate }}</option>
              <option [value]="item.exterior_color_id" *ngFor="let item of exterior_type">
                <ng-container *ngIf="lang === 'en'">{{ item.color_name }}</ng-container>
                <ng-container *ngIf="lang === 'ar'">{{ item.color_name_arabic }}</ng-container>
              </option>
            </select>

            <div class="form-errors" *ngIf="formData.exterior_color_id.invalid && this.submitted">
              <p class="form-errors__error" *ngIf="formData.exterior_color_id.errors.required">
                <!-- Exterior colour is required. -->
                {{ 'errors.info.exterior_colour.required' | translate }}
              </p>
            </div>
          </div>
        </div>

        <div class="col-sm-6 col-md-4 mb-3">
          <div class="form-group">
            <label class="credential2__label">{{ 'information.body_type' | translate }}</label>
            <select
              name="body_type_id"
              formControlName="body_type_id"
              class="credential3__select form-control"
              [class.is-invalid]="formData.body_type_id.invalid && submitted"
              [attr.disabled]="
                role === 'estimator' || role === 'qc' || role === 'purchasemanager' ? '' : null
              "
              (change)="bodyTypeChecker($event)"
            >
              <option value="">{{ 'information.select_body_type' | translate }}</option>
              <option [value]="item.body_type_id" *ngFor="let item of body_type">
                <ng-container *ngIf="lang === 'en'">{{ item.body_type_name }}</ng-container>
                <ng-container *ngIf="lang === 'ar'">{{ item.body_type_name_arabic }}</ng-container>
              </option>
            </select>

            <div class="form-errors" *ngIf="formData.body_type_id.invalid && this.submitted">
              <p class="form-errors__error" *ngIf="formData.body_type_id.errors.required">
                <!-- Body type is required. -->
                {{ 'errors.info.body_type.required' | translate }}
              </p>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-md-4 mb-3">
          <div class="form-group">
            <label class="credential2__label">{{ 'information.upholstery' | translate }}</label>
            <select
              name="uphoistery_id"
              formControlName="uphoistery_id"
              class="credential3__select form-control"
              [class.is-invalid]="formData.uphoistery_id.invalid && submitted"
              [attr.disabled]="
                role === 'estimator' || role === 'qc' || role === 'purchasemanager' ? '' : null
              "
            >
              <option value="" [disabled]="true">
                {{ 'information.select_upholstery' | translate }}
              </option>
              <option [value]="item.uphoistery_id" *ngFor="let item of uphoistery">
                <ng-container *ngIf="lang == 'en'">{{ item.uphoistery_name }}</ng-container>
                <ng-container *ngIf="lang == 'ar'">{{ item.uphoistery_name_arabic }}</ng-container>
              </option>
            </select>

            <div class="form-errors" *ngIf="formData.uphoistery_id.invalid && this.submitted">
              <p class="form-errors__error" *ngIf="formData.uphoistery_id.errors.required">
                <!-- Uphoistery is required. -->
                {{ 'errors.info.upholstery.required' | translate }}
              </p>

              <!-- <p class="form-errors__error" *ngIf="formData.uphoistery_id.errors.pattern">
                Uphoistery should be alphabetical only.
              </p> -->
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-md-4 mb-3">
          <div class="form-group">
            <label class="credential2__label">{{
              'information.interior_colour' | translate
            }}</label>
            <select
              name="interior_color_id"
              formControlName="interior_color_id"
              class="credential3__select form-control"
              [class.is-invalid]="formData.interior_color_id.invalid && submitted"
              [attr.disabled]="
                role === 'estimator' || role === 'qc' || role === 'purchasemanager' ? '' : null
              "
            >
              <option value="">{{ 'information.select_interior_colour' | translate }}</option>
              <option [value]="item.interior_color_id" *ngFor="let item of interior_type">
                <ng-container *ngIf="lang === 'en'">{{ item.color_name }}</ng-container>
                <ng-container *ngIf="lang === 'ar'">{{ item.color_name_arabic }}</ng-container>
              </option>
            </select>

            <div class="form-errors" *ngIf="formData.interior_color_id.invalid && this.submitted">
              <p class="form-errors__error" *ngIf="formData.interior_color_id.errors.required">
                <!-- Interior colour is required. -->
                {{ 'errors.info.interior_colour.required' | translate }}
              </p>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-md-4 mb-3">
          <div class="form-group">
            <label class="credential2__label">{{ 'information.drive_type' | translate }}</label>
            <select
              name="drive_type_id"
              formControlName="drive_type_id"
              class="credential3__select form-control"
              [class.is-invalid]="formData.drive_type_id.invalid && submitted"
              [attr.disabled]="
                role === 'estimator' || role === 'qc' || role === 'purchasemanager' ? '' : null
              "
            >
              <option value="">{{ 'information.select_drive_type' | translate }}</option>
              <option [value]="item.drive_type_id" *ngFor="let item of drive_type">
                <ng-container *ngIf="lang === 'en'">{{ item.drive_type_name }}</ng-container>
                <ng-container *ngIf="lang === 'ar'">{{ item.drive_type_name_arabic }}</ng-container>
              </option>
            </select>

            <div class="form-errors" *ngIf="formData.drive_type_id.invalid && this.submitted">
              <p class="form-errors__error" *ngIf="formData.drive_type_id.errors.required">
                <!-- Drive type is required. -->
                {{ 'errors.info.drive_type.required' | translate }}
              </p>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-md-4 mb-3">
          <div class="form-group">
            <label class="credential2__label">{{ 'information.doors' | translate }}</label>
            <select
              name="door_type_id"
              formControlName="door_type_id"
              class="credential3__select form-control"
              [class.is-invalid]="formData.door_type_id.invalid && submitted"
              [attr.disabled]="
                role === 'estimator' || role === 'qc' || role === 'purchasemanager' ? '' : null
              "
            >
              <option value="">{{ 'information.select_doors' | translate }}</option>
              <option [value]="item.door_type_id" *ngFor="let item of doors_type">
                <ng-container *ngIf="lang == 'en'">{{ item.door_type_name }}</ng-container>
                <ng-container *ngIf="lang == 'ar'">{{ item.door_type_name_arabic }}</ng-container>
              </option>
            </select>

            <div class="form-errors" *ngIf="formData.door_type_id.invalid && this.submitted">
              <p class="form-errors__error" *ngIf="formData.door_type_id.errors.required">
                <!-- Doors is required. -->
                {{ 'errors.info.doors.required' | translate }}
              </p>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-md-4 mb-3">
          <div class="form-group">
            <label class="credential2__label">{{ 'information.cod' | translate }}</label>
            <select
              name="cod_id"
              formControlName="cod_id"
              class="credential3__select form-control"
              [class.is-invalid]="formData.cod_id.invalid && submitted"
              [attr.disabled]="
                role === 'estimator' || role === 'qc' || role === 'purchasemanager' ? '' : null
              "
            >
              <option value="" [disabled]="true">{{ 'information.select_cod' | translate }}</option>
              <option [value]="cod.cod_id" *ngFor="let cod of cod_type">
                <ng-container *ngIf="lang == 'en'">{{ cod.cod_value }}</ng-container>
                <ng-container *ngIf="lang == 'ar'">{{ cod.cod_value_arabic }}</ng-container>
              </option>
            </select>

            <div class="form-errors" *ngIf="formData.cod_id.invalid && this.submitted">
              <p class="form-errors__error" *ngIf="formData.cod_id.errors.required">
                COD is required.
                {{ 'errors.info.cod.required' | translate }}
              </p>
            </div>
          </div>
        </div>

        <div class="col-sm-6 col-md-4 mb-3">
          <div class="form-group">
            <label class="credential2__label">{{ 'information.wheel_base' | translate }}</label>
            <select
              name="wheel_base_id"
              formControlName="wheel_base_id"
              class="credential3__select form-control"
              [class.is-invalid]="formData.wheel_base_id.invalid && submitted"
              [attr.disabled]="
                role === 'estimator' || role === 'qc' || role === 'purchasemanager' ? '' : null
              "
            >
              <option value="">{{ 'information.select_wheel_base' | translate }}</option>
              <option [value]="item.wheel_base_id" *ngFor="let item of wheel_base">
                <ng-container *ngIf="lang === 'en'">{{ item.wheel_base_name }}</ng-container>
                <ng-container *ngIf="lang === 'ar'">{{ item.wheel_base_name_arabic }}</ng-container>
              </option>
            </select>

            <div class="form-errors" *ngIf="formData.wheel_base_id.invalid && this.submitted">
              <p class="form-errors__error" *ngIf="formData.wheel_base_id.errors.required">
                Wheel Base is required.
                <!-- {{ 'errors.info.wheel_base.required' | translate }} -->
              </p>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-md-4 mb-3 d-none d-md-flex" *ngIf="role === 'evaluator'"></div>
        <div class="col-sm-6 col-md-4 mb-3" *ngIf="role === 'admin'">
          <!-- <p>Evaluator</p> -->
          <div class="form-group w-100">
            <!-- <label class="credential2__label">External-estimator</label> -->
            <label class="credential2__label">{{
              'information.external_estimator' | translate
            }}</label>

            <ng-multiselect-dropdown
              [disabled]="disableForm && !editableRole.includes(this.role)"
              [placeholder]="'External-estimator'"
              [settings]="dropdownSettings"
              [data]="dropdownList"
              [(ngModel)]="selectedItems"
              formControlName="external_estimator"
              (onSelect)="onItemSelect($event)"
              (onDeSelect)="onItemDeSelect($event)"
              (onSelectAll)="onSelectAll($event)"
              (onDeSelectAll)="onDeSelectAll($event)"
            >
            </ng-multiselect-dropdown>
          </div>
          <!-- Blank space -->
        </div>
        <div class="col-sm-6 col-md-4 mb-3">
          <div class="form-group">
            <label class="credential2__label">{{ 'information.ownership' | translate }}</label>
            <select
              name="ownership_id"
              formControlName="ownership_id"
              class="credential3__select form-control"
              [class.is-invalid]="formData.ownership_id.invalid && submitted"
              [attr.disabled]="
                role === 'estimator' || role === 'qc' || role === 'purchasemanager' ? '' : null
              "
            >
              <option value="" [disabled]="true">Select ownership</option>
              <option [value]="ownership.ownership_id" *ngFor="let ownership of ownerships">
                <ng-container *ngIf="lang == 'en'">{{ ownership.ownership_name }}</ng-container>
                <ng-container *ngIf="lang == 'ar'">{{
                  ownership.ownership_name_arabic
                }}</ng-container>
              </option>
            </select>

            <div class="form-errors" *ngIf="formData.ownership_id.invalid && this.submitted">
              <p class="form-errors__error" *ngIf="formData.ownership_id.errors.required">
                Ownership is required.
                <!-- {{ 'errors.info.ownership.required' | translate }} -->
              </p>
            </div>
          </div>
        </div>

        <div class="col-sm-6 col-md-4 mb-3">
          <div class="form-group">
            <label class="credential2__label">{{ 'information.utility_type' | translate }}</label>
            <select
              name="utility_type_id"
              formControlName="utility_type_id"
              class="credential3__select form-control"
              [class.is-invalid]="formData.utility_type_id.invalid && submitted"
              [attr.disabled]="
                role === 'estimator' || role === 'qc' || role === 'purchasemanager' ? '' : null
              "
            >
              <option value="">{{ 'information.select_utility_type' | translate }}</option>
              <option [value]="item.utility_type_id" *ngFor="let item of utility_type">
                <ng-container *ngIf="lang === 'en'">{{ item.utility_type_name }}</ng-container>
                <ng-container *ngIf="lang === 'ar'">{{
                  item.utility_type_name_arabic
                }}</ng-container>
              </option>
            </select>

            <div class="form-errors" *ngIf="formData.utility_type_id.invalid && this.submitted">
              <p class="form-errors__error" *ngIf="formData.utility_type_id.errors.required">
                <!-- Utility type is required. -->
                {{ 'errors.info.utility_type.required' | translate }}
              </p>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-md-4 mb-3 d-none d-md-flex" *ngIf="role === 'evaluator'">
          <!-- Blank space -->
        </div>
        <div class="col-sm-6 col-md-4 mb-3">
          <div class="form-group">
            <label class="credential2__label">{{ 'information.finance_status' | translate }}</label>
            <select
              name="mortage_id"
              formControlName="mortage_id"
              class="credential3__select form-control"
              [class.is-invalid]="formData.mortage_id.invalid && submitted"
              [attr.disabled]="
                role === 'estimator' || role === 'qc' || role === 'purchasemanager' ? '' : null
              "
            >
              <option value="" [disabled]="true">Select Finance Status</option>
              <option [value]="mortgage.mortage_id" *ngFor="let mortgage of mortgages">
                <ng-container *ngIf="lang == 'en'">{{ mortgage.mortage_name }}</ng-container>
                <ng-container *ngIf="lang == 'ar'">{{ mortgage.mortage_name_arabic }}</ng-container>
              </option>
            </select>

            <div class="form-errors" *ngIf="formData.mortage_id.invalid && this.submitted">
              <p class="form-errors__error" *ngIf="formData.mortage_id.errors.required">
                Finance status is required.
                <!-- {{ 'errors.info.finance_status.required' | translate }} -->
              </p>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-md-4 mb-3">
          <div class="form-group">
            <label class="credential2__label">{{ 'information.contract_number' | translate }}</label>
            <input
              type="text"
              formControlName="contract_number"
              class="credential3__input form-control"
              placeholder="Contract number"
            />

            <!-- <div class="form-errors" *ngIf="formData.contract_number.invalid && this.submitted">
              <p class="form-errors__error" *ngIf="formData.contract_number.errors.required">
                Contract number is required.
              </p>
            </div> -->
          </div>
        </div>
        <div
          class="col-sm-6 col-md-4 mb-3"
          *ngIf="
            role === 'estimator' || role === 'admin' || role === 'qc' || role === 'purchasemanager'
          "
        >
          <div class="form-group">
            <label class="credential2__label">{{ 'information.warranty' | translate }}</label>

            <select
              name="warranty_id"
              formControlName="warranty_id"
              class="credential3__select form-control"
              [class.is-invalid]="formData.warranty_id.invalid && submitted"
              [attr.disabled]="
                role === 'estimator' || role === 'qc' || role === 'purchasemanager' ? '' : null
              "
            >
              <option value="">{{ 'information.select_warranty' | translate }}</option>
              <option [value]="warranty.warranty_id" *ngFor="let warranty of warranty_type">
                <ng-container *ngIf="lang == 'en'">{{ warranty.warranty_name }}</ng-container>
                <ng-container *ngIf="lang == 'ar'">{{
                  warranty.warranty_name_arabic
                }}</ng-container>
              </option>
            </select>

            <div class="form-errors" *ngIf="formData.warranty_id.invalid && this.submitted">
              <p class="form-errors__error" *ngIf="formData.warranty_id.errors.required">
                <!-- Warranty is required. -->
                {{ 'errors.info.warranty.required' | translate }}
              </p>

              <!-- <p class="form-errors__error" *ngIf="formData.warranty_id.errors.pattern">
                Warranty should be alphabetical only.
              </p> -->
            </div>
          </div>
        </div>
        <div
          class="col-sm-6 col-md-4 mb-3"
          *ngIf="
            role === 'estimator' || role === 'admin' || role === 'qc' || role === 'purchasemanager'
          "
        >
          <div class="form-group">
            <label class="credential2__label">
              {{ 'information.warranty_expiry_date' | translate }}
            </label>
            <input
              type="text"
              name="warranty_expiry_date"
              formControlName="warranty_expiry_date"
              [placeholder]="'information.dd_mm_yyyy' | translate"
              class="credential3__input form-control"
              [attr.disabled]="
                role === 'estimator' || role === 'qc' || role === 'purchasemanager' ? '' : null
              "
              [bsConfig]="dpConfig"
              bsDatepicker
              readonly
            />

            <!-- <div class="form-errors" *ngIf="formData.warranty_expiry_date.invalid && this.submitted">
              <p class="form-errors__error" *ngIf="formData.warranty_expiry_date.errors.required">
                {{ 'errors.info.warranty_expiry_date.required' | translate }}
              </p>
            </div> -->
          </div>
        </div>
        <div
          class="col-sm-6 col-md-4 mb-3"
          *ngIf="
            role === 'estimator' || role === 'admin' || role === 'qc' || role === 'purchasemanager'
          "
        >
          <div class="form-group">
            <label class="credential2__label">{{
              'information.last_service_date' | translate
            }}</label>
            <input
              type="text"
              name="last_service_date"
              formControlName="last_service_date"
              [placeholder]="'information.dd_mm_yyyy' | translate"
              class="credential3__input form-control"
              [attr.disabled]="
                role === 'estimator' || role === 'qc' || role === 'purchasemanager' ? '' : null
              "
              [bsConfig]="dpConfig"
              bsDatepicker
              readonly
            />

            <!-- <div class="form-errors" *ngIf="formData.last_service_date.invalid && this.submitted">
              <p class="form-errors__error" *ngIf="formData.last_service_date.errors.required">
                {{ 'errors.info.last_service_date.required' | translate }}
              </p>
            </div> -->
          </div>
        </div>

        <div
          class="col-sm-6 col-md-4 mb-3"
          *ngIf="
            role === 'estimator' || role === 'admin' || role === 'qc' || role === 'purchasemanager'
          "
        >
          <div class="form-group">
            <label class="credential2__label">{{
              'information.last_service_kilometers' | translate
            }}</label>
            <input
              type="text"
              name="last_service_km"
              formControlName="last_service_km"
              [placeholder]="'information.enter_last_service_kilometers' | translate"
              class="credential3__input form-control"
              [readonly]="role === 'estimator' || role === 'qc' || role === 'purchasemanager'"
            />

            <!-- <div class="form-errors" *ngIf="formData.last_service_km.invalid && this.submitted">
              <p class="form-errors__error" *ngIf="formData.last_service_km.errors.required">
                {{ 'errors.info.last_service_kilometers.required' | translate }}
              </p>

              <p class="form-errors__error" *ngIf="formData.last_service_km.errors.pattern">
                {{ 'errors.info.last_service_kilometers.pattern_1' | translate }}
              </p>
            </div> -->
          </div>
        </div>
        <div
          class="col-sm-6 col-md-4 mb-3"
          *ngIf="
            role === 'estimator' || role === 'admin' || role === 'qc' || role === 'purchasemanager'
          "
        >
          <div class="form-group">
            <label class="credential2__label">{{ 'information.hp' | translate }}</label>
            <select
              name="power_id"
              formControlName="power_id"
              class="credential3__select form-control"
              [class.is-invalid]="formData.power_id.invalid && submitted"
              [attr.disabled]="
                role === 'estimator' || role === 'qc' || role === 'purchasemanager' ? '' : null
              "
            >
              <option value="" [disabled]="true">{{ 'information.enter_hp' | translate }}</option>
              <option [value]="power.power_id" *ngFor="let power of hp">
                <ng-container *ngIf="lang == 'en'">{{ power.power_name }}</ng-container>
                <ng-container *ngIf="lang == 'ar'">{{ power.power_name_arabic }}</ng-container>
              </option>
            </select>

            <div class="form-errors" *ngIf="formData.power_id.invalid && this.submitted">
              <p class="form-errors__error" *ngIf="formData.power_id.errors.required">
                <!-- HP (Horse Power) is required. -->
                {{ 'errors.info.hp_horse_power.required' | translate }}
              </p>
            </div>
          </div>
        </div>
        <div
          class="col-sm-6 col-md-4 mb-3"
          *ngIf="
            role === 'estimator' || role === 'admin' || role === 'qc' || role === 'purchasemanager'
          "
        >
          <div class="form-group">
            <label class="credential2__label">{{ 'information.torque' | translate }}</label>
            <select
              name="torque_id"
              formControlName="torque_id"
              class="credential3__select form-control"
              [class.is-invalid]="formData.torque_id.invalid && submitted"
              [attr.disabled]="
                role === 'estimator' || role === 'qc' || role === 'purchasemanager' ? '' : null
              "
            >
              <option value="" [disabled]="true">
                {{ 'information.enter_torque' | translate }}
              </option>
              <option [value]="item.torque_id" *ngFor="let item of torque">
                <ng-container *ngIf="lang == 'en'">{{ item.torque_name }}</ng-container>
                <ng-container *ngIf="lang == 'ar'">{{ item.torque_name_arabic }}</ng-container>
              </option>
            </select>

            <div class="form-errors" *ngIf="formData.torque_id.invalid && this.submitted">
              <p class="form-errors__error" *ngIf="formData.torque_id.errors.required">
                <!-- Torque is required. -->
                {{ 'errors.info.torque.required' | translate }}
              </p>

              <!-- <p class="form-errors__error" *ngIf="formData.torque_id.errors.pattern">
                Torque should be alphanumerical only.
              </p> -->
            </div>
          </div>
        </div>

        <div
          class="col-sm-6 col-md-4 mb-3"
          *ngIf="
            role === 'estimator' || role === 'admin' || role === 'qc' || role === 'purchasemanager'
          "
        >
          <div class="form-group">
            <label class="credential2__label">{{ 'information.acceleration' | translate }}</label>
            <select
              name="acceleration_id"
              formControlName="acceleration_id"
              class="credential3__select form-control"
              [class.is-invalid]="formData.acceleration_id.invalid && submitted"
              [attr.disabled]="
                role === 'estimator' || role === 'qc' || role === 'purchasemanager' ? '' : null
              "
            >
              <option value="" [disabled]="true">
                {{ 'information.enter_acceleration' | translate }}
              </option>
              <option [value]="speed.acceleration_id" *ngFor="let speed of acceleration">
                <ng-container *ngIf="lang == 'en'">{{ speed.acceleration_value }}</ng-container>
                <ng-container *ngIf="lang == 'ar'">{{
                  speed.acceleration_value_arabic
                }}</ng-container>
              </option>
            </select>

            <div class="form-errors" *ngIf="formData.acceleration_id.invalid && this.submitted">
              <p class="form-errors__error" *ngIf="formData.acceleration_id.errors.required">
                <!-- Acceleration is required. -->
                {{ 'errors.info.acceleration.required' | translate }}
              </p>
            </div>
          </div>
        </div>
        <div
          class="col-sm-6 col-md-4 mb-3"
          *ngIf="
            role === 'estimator' || role === 'admin' || role === 'qc' || role === 'purchasemanager'
          "
        >
          <div class="form-group">
            <label class="credential2__label">
              {{ 'information.estimara_expiry_date' | translate }}

              <a
                href="javascript:void(0)"
                class="btn btn__action dpToggle p-0 ml-auto"
                (click)="dpToggle('estemara')"
              >
                <span class="text-truncate" *ngIf="!estExpToggle">Ar</span>
                <span class="text-truncate" *ngIf="estExpToggle">En</span>
              </a>

              <button
                type="button"
                class="btn btn__action ml-3"
                [id]="'information.estimara_expiry_date' | translate"
                (click)="openUpload($event, 'estimara_expiry_date')"
              >
                <ion-icon name="image-outline" class="ion-lg"></ion-icon>
              </button>
            </label>
            <input
              type="text"
              name="estimara_expiry_date"
              formControlName="estimara_expiry_date"
              [placeholder]="'information.dd_mm_yyyy' | translate"
              class="credential3__input form-control"
              [class.is-invalid]="formData.estimara_expiry_date.invalid && submitted"
              [attr.disabled]="
                role === 'estimator' || role === 'qc' || role === 'purchasemanager' ? '' : null
              "
              [bsConfig]="dpConfig"
              bsDatepicker
              readonly
              *ngIf="!estExpToggle"
            />

            <input
              type="text"
              name="estimara_expiry_date"
              formControlName="estimara_expiry_date"
              [placeholder]="'validation.estimara_expiry_date' | translate"
              class="form-control credential3__input"
              [class.is-invalid]="formData.estimara_expiry_date.invalid && this.submitted"
              [attr.disabled]="
                role === 'estimator' || role === 'qc' || role === 'purchasemanager' ? '' : null
              "
              id="est_exp_date"
              autocomplete="off"
              *ngIf="estExpToggle"
            />

            <div
              class="form-errors"
              *ngIf="formData.estimara_expiry_date.invalid && this.submitted"
            >
              <p class="form-errors__error" *ngIf="formData.estimara_expiry_date.errors.required">
                <!-- Estimara expiry date is required. -->
                {{ 'errors.info.estimara_expiry_date.required' | translate }}
              </p>
            </div>
          </div>
        </div>
        <div
          class="col-sm-6 col-md-4 mb-3"
          *ngIf="
            role === 'estimator' || role === 'admin' || role === 'qc' || role === 'purchasemanager'
          "
        >
          <div class="form-group">
            <label class="credential2__label">
              {{ 'information.mvpi_expiry_date' | translate }}

              <a
                href="javascript:void(0)"
                class="btn btn__action dpToggle ml-auto p-0"
                (click)="dpToggle('mvpi')"
              >
                <span class="text-truncate" *ngIf="!mvpiExpToggle">Ar</span>
                <span class="text-truncate" *ngIf="mvpiExpToggle">En</span>
              </a>

              <button
                type="button"
                class="btn btn__action ml-3"
                [id]="'information.mvpi_expiry_date' | translate"
                (click)="openUpload($event, 'mvpi_expiry_date')"
              >
                <ion-icon name="image-outline" class="ion-lg"></ion-icon>
              </button>
            </label>
            <input
              type="text"
              name="mvpi_expiry_date"
              formControlName="mvpi_expiry_date"
              [placeholder]="'information.dd_mm_yyyy' | translate"
              class="credential3__input form-control"
              [attr.disabled]="
                role === 'estimator' || role === 'qc' || role === 'purchasemanager' ? '' : null
              "
              [bsConfig]="dpConfig"
              bsDatepicker
              readonly
              *ngIf="!mvpiExpToggle"
            />

            <input
              type="text"
              name="mvpi_expiry_date"
              formControlName="mvpi_expiry_date"
              [placeholder]="'validation.MVPI_expiry_date' | translate"
              class="form-control credential3__input"
              [class.is-invalid]="formData.mvpi_expiry_date.invalid && this.submitted"
              [attr.disabled]="
                role === 'estimator' || role === 'qc' || role === 'purchasemanager' ? '' : null
              "
              id="mvpi_exp_date"
              autocomplete="off"
              *ngIf="mvpiExpToggle"
            />

            <!-- <div class="form-errors" *ngIf="formData.mvpi_expiry_date.invalid && this.submitted">
              <p class="form-errors__error" *ngIf="formData.mvpi_expiry_date.errors.required">
                {{ 'errors.info.mvpi_expiry_date.required' | translate }}
              </p>
            </div> -->
          </div>
        </div>
        <!-- 'reconditioning_manager' -->
        <div
          class="col-sm-6 col-md-4 mb-3"
          [hidden]="!['estimator', 'evaluator', 'admin', 'qc', 'purchasemanager'].includes(role)"
        >
          <div class="form-group">
            <label class="credential2__label">{{
              'information.information_market_acceptability' | translate
            }}</label>
            <select
              name="market_acceptabilitie_id"
              formControlName="market_acceptabilitie_id"
              class="credential3__select form-control"
              [class.is-invalid]="formData.market_acceptabilitie_id.invalid && submitted"
            >
              <!-- [attr.disabled]=" [ 'purchaser', 'purchasemanager', 'salesperson', 'salesmanager' ].includes(role) ? true : false" -->
              <option [ngValue]="null" disabled>
                {{ 'information.information_market_acceptability' | translate }}
              </option>
              <option
                [value]="item.market_acceptabilitie_id"
                *ngFor="let item of acceptabilityData"
              >
                <ng-container *ngIf="lang == 'en'">{{
                  item.market_acceptabilitie_name | titlecase
                }}</ng-container>
                <ng-container *ngIf="lang == 'ar'">{{
                  item.market_acceptabilitie_arabic_name
                }}</ng-container>
              </option>
            </select>

            <div
              class="form-errors"
              *ngIf="formData.market_acceptabilitie_id.invalid && this.submitted"
            >
              <p
                class="form-errors__error"
                *ngIf="formData.market_acceptabilitie_id.errors.required"
              >
                <!-- Warranty is required. -->
                {{ 'errors.info.market.acceptability.required' | translate }}
              </p>

              <!-- <p class="form-errors__error" *ngIf="formData.market_acceptabilitie_id.errors.pattern">
                Warranty should be alphabetical only.
              </p> -->
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-md-4 mb-3 d-none">
          <div class="form-group">
            <label class="credential2__label">{{
              'information.test_drive_video' | translate
            }}</label>
            <input
              type="text"
              name="test_drive_video"
              formControlName="test_drive_video"
              class="form-control credential3__input"
              [placeholder]="'information.test_drive_video' | translate"
              [class.is-invalid]="formData.test_drive_video.invalid && submitted"
            />

            <!-- <div class="form-errors" *ngIf="formData.test_drive_video.invalid && this.submitted">
              <p class="form-errors__error" *ngIf="formData.test_drive_video.errors.required">
                {{ 'errors.info.market.acceptability.required' | translate }}
              </p>
            </div> -->
          </div>
        </div>
      </div>
      <div
        class="information__btnGrp mt-4"
        *ngIf="role === 'evaluator' || role === 'admin' || editableRole.includes(role)"
      >
        <div class="row mx-n2">
          <!-- <div class="col-sm-6 px-2 mb-3 mb-sm-0">
            <button type="button" class="btn btn__tertiary w-100">
              {{ 'close' | translate }}
            </button>
          </div> -->
          <div class="col-sm-6 px-2 mx-auto">
            <button
              *ngIf="!disableForm || (editableRole.includes(role) && disableForm)"
              type="submit"
              class="btn btn__primary w-100"
              [disabled]="submitLoad"
            >
              {{ 'save' | translate }}
              <span class="spinner-grow spinner-grow-sm text-light ml-2" [hidden]="!submitLoad">
              </span>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>

<loader [active]="loaded"></loader>

<!-- Modal -->
<div class="modal fade" bsModal #upload="bs-modal" (onHidden)="file = null">
  <div class="modal-dialog uploadModal">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title pull-left">Upload Image</h4>
        <button type="button" class="close" (click)="upload.hide()">
          <i class="bi bi-x"></i>
        </button>
      </div>
      <form class="condition__form credential" [formGroup]="uploader" (submit)="saveImg(fieldType)">
        <div class="modal-body previewModal optionsModal__body">
          <div class="vam_show_car_form_container">
            <div class="row mx-n2">
              <div class="col-12 px-2">
                <label for="" class="credential__label"> {{ title }} </label>

                <div class="form-group">
                  <label for="infoImage" class="credential__file m-0">
                    <input
                      type="file"
                      name="infoImage"
                      formControlName="infoImage"
                      class="form-conrol d-none"
                      id="infoImage"
                      (change)="getFile($event)"
                    />
                    <img
                      src="assets/images/car-image_icon.svg"
                      *ngIf="!file && !imagePreviewCurrent"
                    />
                    <img
                      [src]="imagePreviewCurrent"
                      class="image-preview"
                      *ngIf="!file && imagePreviewCurrent"
                    />
                    <p class="fs fs__md" *ngIf="file">
                      {{ file.name }}
                    </p>
                  </label>
                </div>

                <p
                  class="fs fs__sm text-center color-gray m-0"
                  *ngIf="!file && imagePreviewCurrent"
                >
                  Click on the image to replace.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer conditionModal__footer">
          <div class="conditionModal__footerInner">
            <div class="row w-100 mx-0">
              <div
                class="col-md-6 mx-auto px-0"
                *ngIf="!disableForm || editableRole.includes(role)"
              >
                <button type="submit" class="btn btn__primary w-100" [disabled]="uploading">
                  Done
                  <span class="spinner-grow spinner-grow-sm text-light ml-2" [hidden]="!uploading">
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<div class="modal fade" bsModal #confirm="bs-modal">
  <div class="modal-dialog bodyTypeConfirmModal">
    <div class="modal-content">
      <div class="modal-body conditionModal__body p-4">
        <div class="warning-text">
          <p class="d-flex align-items-center fs fs__md">
            <ion-icon name="information-circle" class="ion-3x color-yellow mr-2"></ion-icon>
            You have selected new body type. Saving this form now will remove all the rating for
            previously selected body type.
          </p>
        </div>
      </div>
      <div class="modal-footer conditionModal__footer">
        <div class="conditionModal__footerInner p-0">
          <div class="row w-100 mx-0">
            <div class="col-md-6 ml-sm-auto px-0">
              <div class="conditionModal__btnGrp">
                <button type="button" class="btn btn__primary w-100" (click)="confirm.hide()">
                  Ok
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
